const topBrands = new Set([
  "amazon-com",
  "best-buy",
  "dell",
  "hotels-com",
  "itunes",
  "jcpenney",
  "kmart",
  "kohl-s",
  "lowe-s",
  "macy-s",
  "nike",
  "nordstrom",
  "sears",
  "sephora",
  "staples",
  "starbucks-coffee",
  "t-j-maxx",
  "target",
  "the-home-depot",
  "walmart"
]);

const brandsForCampaign = new Set([
  "adidas",
  "airbnb",
  "cabela-s",
  "fanatics",
  "gamestop",
  "h-m",
  "hotels-com",
  "kmart",
  "lowe-s",
  "macy-s",
  "overstock",
  "petco",
  "nintendo-eshop",
  "panera-bread",
  "reebok",
  "sears",
  "sephora",
  "southwest-airlines",
  "under-armour",
  "walmart"
]);

export { topBrands, brandsForCampaign };
